/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetTechMapsCategoriesDocument = gql`
    query GetTechMapsCategories($page: Int, $itemsPerPage: Int, $delete: Boolean, $branchId: Int!) {
  TechMapCategories(
    page: $page
    itemsPerPage: $itemsPerPage
    delete: $delete
    branchId: $branchId
  ) {
    items {
      id
      name
      comment
      deleted
      parentCategory {
        id
        name
        deleted
      }
      company {
        id
        name
        address
        phone
        website
        deleted
        bookingQrLink
        isPremiumOn
        paidFeaturesPaginated {
          totalCount
        }
      }
      childCategories {
        id
        name
        deleted
        parentCategory {
          id
          name
          deleted
        }
      }
    }
  }
}
    `;

/**
 * __useGetTechMapsCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTechMapsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechMapsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechMapsCategoriesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      delete: // value for 'delete'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useGetTechMapsCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables> & ({ variables: GetTechMapsCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables>(GetTechMapsCategoriesDocument, options);
      }
export function useGetTechMapsCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables>(GetTechMapsCategoriesDocument, options);
        }
export function useGetTechMapsCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables>(GetTechMapsCategoriesDocument, options);
        }
export type GetTechMapsCategoriesQueryHookResult = ReturnType<typeof useGetTechMapsCategoriesQuery>;
export type GetTechMapsCategoriesLazyQueryHookResult = ReturnType<typeof useGetTechMapsCategoriesLazyQuery>;
export type GetTechMapsCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTechMapsCategoriesSuspenseQuery>;
export type GetTechMapsCategoriesQueryResult = Apollo.QueryResult<GetTechMapsCategoriesQuery, GetTechMapsCategoriesQueryVariables>;
export const GetTechnologicalMapsDocument = gql`
    query GetTechnologicalMaps($page: Int, $itemsPerPage: Int, $search: String, $categoryId: Int, $isDeleted: Boolean, $techMapId: Int, $pageTechMapProducts: Int, $itemsPerPageTechMapProducts: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      technologicalMaps(
        page: $page
        itemsPerPage: $itemsPerPage
        search: $search
        categoryId: $categoryId
        isDeleted: $isDeleted
        techMapId: $techMapId
      ) {
        currentPage
        itemsPerPage
        pageCount
        totalCount
        technologicalMaps {
          id
          name
          description
          deleted
          technologicalMapNewCategory {
            id
            name
            deleted
            parentCategory {
              id
              name
              deleted
            }
          }
          technologicalMapProductRelations {
            id
            unit {
              id
              name
            }
            product {
              id
              name
              deleted
              cost
              price
            }
            requiredQuantity
          }
          techMapProducts(
            page: $pageTechMapProducts
            itemsPerPage: $itemsPerPageTechMapProducts
          ) {
            totalCount
            techMapProducts {
              id
              requiredQuantity
            }
          }
          techMapServices(connected: true, itemsPerPage: 10000) {
            techMapServices {
              id
              connect
            }
          }
          technologicalMapServiceRelations {
            id
            connect
            service {
              id
              name
              description
              deleted
              onlineRegistration
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTechnologicalMapsQuery__
 *
 * To run a query within a React component, call `useGetTechnologicalMapsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechnologicalMapsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechnologicalMapsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      search: // value for 'search'
 *      categoryId: // value for 'categoryId'
 *      isDeleted: // value for 'isDeleted'
 *      techMapId: // value for 'techMapId'
 *      pageTechMapProducts: // value for 'pageTechMapProducts'
 *      itemsPerPageTechMapProducts: // value for 'itemsPerPageTechMapProducts'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetTechnologicalMapsQuery(baseOptions: Apollo.QueryHookOptions<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables> & ({ variables: GetTechnologicalMapsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables>(GetTechnologicalMapsDocument, options);
      }
export function useGetTechnologicalMapsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables>(GetTechnologicalMapsDocument, options);
        }
export function useGetTechnologicalMapsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables>(GetTechnologicalMapsDocument, options);
        }
export type GetTechnologicalMapsQueryHookResult = ReturnType<typeof useGetTechnologicalMapsQuery>;
export type GetTechnologicalMapsLazyQueryHookResult = ReturnType<typeof useGetTechnologicalMapsLazyQuery>;
export type GetTechnologicalMapsSuspenseQueryHookResult = ReturnType<typeof useGetTechnologicalMapsSuspenseQuery>;
export type GetTechnologicalMapsQueryResult = Apollo.QueryResult<GetTechnologicalMapsQuery, GetTechnologicalMapsQueryVariables>;
export const GetTechMapServicesDocument = gql`
    query GetTechMapServices($techMapId: Int!, $page: Int, $itemsPerPage: Int, $search: String, $categoryId: Int, $companyId: Int!, $connect: Boolean) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      servicesListForTechMap(
        techMapId: $techMapId
        page: $page
        itemsPerPage: $itemsPerPage
        search: $search
        categoryId: $categoryId
      ) {
        services {
          id
          name
          description
          serviceCategoryNew {
            id
            name
            parentCategory {
              id
              name
              deleted
            }
            childCategories {
              id
              name
              deleted
            }
            deleted
          }
          onlineRegistration
          deleted
          technologicalMapServiceRelations(techMapId: $techMapId, connect: $connect) {
            id
            connect
            service {
              id
              name
              deleted
              onlineRegistration
            }
          }
        }
        totalCount
        currentPage
        itemsPerPage
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetTechMapServicesQuery__
 *
 * To run a query within a React component, call `useGetTechMapServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechMapServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechMapServicesQuery({
 *   variables: {
 *      techMapId: // value for 'techMapId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      search: // value for 'search'
 *      categoryId: // value for 'categoryId'
 *      companyId: // value for 'companyId'
 *      connect: // value for 'connect'
 *   },
 * });
 */
export function useGetTechMapServicesQuery(baseOptions: Apollo.QueryHookOptions<GetTechMapServicesQuery, GetTechMapServicesQueryVariables> & ({ variables: GetTechMapServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTechMapServicesQuery, GetTechMapServicesQueryVariables>(GetTechMapServicesDocument, options);
      }
export function useGetTechMapServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTechMapServicesQuery, GetTechMapServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTechMapServicesQuery, GetTechMapServicesQueryVariables>(GetTechMapServicesDocument, options);
        }
export function useGetTechMapServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTechMapServicesQuery, GetTechMapServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTechMapServicesQuery, GetTechMapServicesQueryVariables>(GetTechMapServicesDocument, options);
        }
export type GetTechMapServicesQueryHookResult = ReturnType<typeof useGetTechMapServicesQuery>;
export type GetTechMapServicesLazyQueryHookResult = ReturnType<typeof useGetTechMapServicesLazyQuery>;
export type GetTechMapServicesSuspenseQueryHookResult = ReturnType<typeof useGetTechMapServicesSuspenseQuery>;
export type GetTechMapServicesQueryResult = Apollo.QueryResult<GetTechMapServicesQuery, GetTechMapServicesQueryVariables>;
export const GetOneTechMapDocument = gql`
    query GetOneTechMap($techMapId: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      technologicalMaps(techMapId: $techMapId) {
        technologicalMaps {
          id
          name
          description
          deleted
          technologicalMapNewCategory {
            id
            name
            deleted
            parentCategory {
              id
              name
              deleted
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOneTechMapQuery__
 *
 * To run a query within a React component, call `useGetOneTechMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneTechMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneTechMapQuery({
 *   variables: {
 *      techMapId: // value for 'techMapId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetOneTechMapQuery(baseOptions: Apollo.QueryHookOptions<GetOneTechMapQuery, GetOneTechMapQueryVariables> & ({ variables: GetOneTechMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneTechMapQuery, GetOneTechMapQueryVariables>(GetOneTechMapDocument, options);
      }
export function useGetOneTechMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneTechMapQuery, GetOneTechMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneTechMapQuery, GetOneTechMapQueryVariables>(GetOneTechMapDocument, options);
        }
export function useGetOneTechMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOneTechMapQuery, GetOneTechMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOneTechMapQuery, GetOneTechMapQueryVariables>(GetOneTechMapDocument, options);
        }
export type GetOneTechMapQueryHookResult = ReturnType<typeof useGetOneTechMapQuery>;
export type GetOneTechMapLazyQueryHookResult = ReturnType<typeof useGetOneTechMapLazyQuery>;
export type GetOneTechMapSuspenseQueryHookResult = ReturnType<typeof useGetOneTechMapSuspenseQuery>;
export type GetOneTechMapQueryResult = Apollo.QueryResult<GetOneTechMapQuery, GetOneTechMapQueryVariables>;
export const GetConnectedServicesDocument = gql`
    query getConnectedServices($techMapId: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      technologicalMaps(techMapId: $techMapId) {
        technologicalMaps {
          id
          name
          deleted
          technologicalMapServiceRelations(connected: true) {
            id
            connect
            service {
              id
              name
              onlineRegistration
              deleted
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetConnectedServicesQuery__
 *
 * To run a query within a React component, call `useGetConnectedServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConnectedServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConnectedServicesQuery({
 *   variables: {
 *      techMapId: // value for 'techMapId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetConnectedServicesQuery(baseOptions: Apollo.QueryHookOptions<GetConnectedServicesQuery, GetConnectedServicesQueryVariables> & ({ variables: GetConnectedServicesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>(GetConnectedServicesDocument, options);
      }
export function useGetConnectedServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>(GetConnectedServicesDocument, options);
        }
export function useGetConnectedServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>(GetConnectedServicesDocument, options);
        }
export type GetConnectedServicesQueryHookResult = ReturnType<typeof useGetConnectedServicesQuery>;
export type GetConnectedServicesLazyQueryHookResult = ReturnType<typeof useGetConnectedServicesLazyQuery>;
export type GetConnectedServicesSuspenseQueryHookResult = ReturnType<typeof useGetConnectedServicesSuspenseQuery>;
export type GetConnectedServicesQueryResult = Apollo.QueryResult<GetConnectedServicesQuery, GetConnectedServicesQueryVariables>;
export const GetServiceDocument = gql`
    query GetService($id: Int, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      services(id: $id) {
        services {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetServiceQuery(baseOptions: Apollo.QueryHookOptions<GetServiceQuery, GetServiceQueryVariables> & ({ variables: GetServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
      }
export function useGetServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export function useGetServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<typeof useGetServiceLazyQuery>;
export type GetServiceSuspenseQueryHookResult = ReturnType<typeof useGetServiceSuspenseQuery>;
export type GetServiceQueryResult = Apollo.QueryResult<GetServiceQuery, GetServiceQueryVariables>;
export const GetTechMapsForServiceDocument = gql`
    query GetTechMapsForService($page: Int, $itemsPerPage: Int, $search: String, $categoryId: Int, $companyId: Int!, $connect: Boolean, $serviceId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      techMapListForServices(
        serviceId: $serviceId
        page: $page
        itemsPerPage: $itemsPerPage
        search: $search
        categoryId: $categoryId
      ) {
        technologicalMaps {
          id
          name
          description
          technologicalMapNewCategory {
            id
            name
            deleted
            parentCategory {
              id
              name
              deleted
            }
            childCategories {
              id
              name
              deleted
            }
            deleted
          }
          deleted
          technologicalMapServiceRelations(serviceId: $serviceId, connected: $connect) {
            id
            connect
            technologicalMap {
              id
              name
              deleted
            }
          }
        }
        totalCount
        currentPage
        itemsPerPage
        pageCount
      }
    }
  }
}
    `;

/**
 * __useGetTechMapsForServiceQuery__
 *
 * To run a query within a React component, call `useGetTechMapsForServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTechMapsForServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTechMapsForServiceQuery({
 *   variables: {
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *      search: // value for 'search'
 *      categoryId: // value for 'categoryId'
 *      companyId: // value for 'companyId'
 *      connect: // value for 'connect'
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetTechMapsForServiceQuery(baseOptions: Apollo.QueryHookOptions<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables> & ({ variables: GetTechMapsForServiceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables>(GetTechMapsForServiceDocument, options);
      }
export function useGetTechMapsForServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables>(GetTechMapsForServiceDocument, options);
        }
export function useGetTechMapsForServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables>(GetTechMapsForServiceDocument, options);
        }
export type GetTechMapsForServiceQueryHookResult = ReturnType<typeof useGetTechMapsForServiceQuery>;
export type GetTechMapsForServiceLazyQueryHookResult = ReturnType<typeof useGetTechMapsForServiceLazyQuery>;
export type GetTechMapsForServiceSuspenseQueryHookResult = ReturnType<typeof useGetTechMapsForServiceSuspenseQuery>;
export type GetTechMapsForServiceQueryResult = Apollo.QueryResult<GetTechMapsForServiceQuery, GetTechMapsForServiceQueryVariables>;
export const CreateTechMapDocument = gql`
    mutation CreateTechMap($companyId: Int!, $input: TechnologicalMapInput!, $branchId: Int!) {
  createTechnologicalMap(
    companyId: $companyId
    input: $input
    branchId: $branchId
  ) {
    id
    name
    description
    technologicalMapProductRelations {
      id
      unit {
        id
        name
      }
      requiredQuantity
    }
    technologicalMapServiceRelations {
      id
      connect
      service {
        id
        deleted
        name
        onlineRegistration
      }
    }
  }
}
    `;
export type CreateTechMapMutationFn = Apollo.MutationFunction<CreateTechMapMutation, CreateTechMapMutationVariables>;

/**
 * __useCreateTechMapMutation__
 *
 * To run a mutation, you first call `useCreateTechMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTechMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTechMapMutation, { data, loading, error }] = useCreateTechMapMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCreateTechMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateTechMapMutation, CreateTechMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTechMapMutation, CreateTechMapMutationVariables>(CreateTechMapDocument, options);
      }
export type CreateTechMapMutationHookResult = ReturnType<typeof useCreateTechMapMutation>;
export type CreateTechMapMutationResult = Apollo.MutationResult<CreateTechMapMutation>;
export type CreateTechMapMutationOptions = Apollo.BaseMutationOptions<CreateTechMapMutation, CreateTechMapMutationVariables>;
export const CreateTechMapsCategoryDocument = gql`
    mutation CreateTechMapsCategory($companyId: Int!, $input: TechMapCategoryNewInput!, $branchId: Int!) {
  createTechMapCategory(companyId: $companyId, input: $input, branchId: $branchId) {
    id
    name
    comment
    parentCategory {
      id
      name
      deleted
    }
    deleted
  }
}
    `;
export type CreateTechMapsCategoryMutationFn = Apollo.MutationFunction<CreateTechMapsCategoryMutation, CreateTechMapsCategoryMutationVariables>;

/**
 * __useCreateTechMapsCategoryMutation__
 *
 * To run a mutation, you first call `useCreateTechMapsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTechMapsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTechMapsCategoryMutation, { data, loading, error }] = useCreateTechMapsCategoryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useCreateTechMapsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTechMapsCategoryMutation, CreateTechMapsCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTechMapsCategoryMutation, CreateTechMapsCategoryMutationVariables>(CreateTechMapsCategoryDocument, options);
      }
export type CreateTechMapsCategoryMutationHookResult = ReturnType<typeof useCreateTechMapsCategoryMutation>;
export type CreateTechMapsCategoryMutationResult = Apollo.MutationResult<CreateTechMapsCategoryMutation>;
export type CreateTechMapsCategoryMutationOptions = Apollo.BaseMutationOptions<CreateTechMapsCategoryMutation, CreateTechMapsCategoryMutationVariables>;
export const UpdateTechnologicalMapDocument = gql`
    mutation UpdateTechnologicalMap($technologicalMapId: Int!, $input: TechnologicalMapInput!, $branchId: Int!) {
  updateTechnologicalMap(
    technologicalMapId: $technologicalMapId
    input: $input
    branchId: $branchId
  ) {
    id
    name
    description
  }
}
    `;
export type UpdateTechnologicalMapMutationFn = Apollo.MutationFunction<UpdateTechnologicalMapMutation, UpdateTechnologicalMapMutationVariables>;

/**
 * __useUpdateTechnologicalMapMutation__
 *
 * To run a mutation, you first call `useUpdateTechnologicalMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechnologicalMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTechnologicalMapMutation, { data, loading, error }] = useUpdateTechnologicalMapMutation({
 *   variables: {
 *      technologicalMapId: // value for 'technologicalMapId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateTechnologicalMapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTechnologicalMapMutation, UpdateTechnologicalMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTechnologicalMapMutation, UpdateTechnologicalMapMutationVariables>(UpdateTechnologicalMapDocument, options);
      }
export type UpdateTechnologicalMapMutationHookResult = ReturnType<typeof useUpdateTechnologicalMapMutation>;
export type UpdateTechnologicalMapMutationResult = Apollo.MutationResult<UpdateTechnologicalMapMutation>;
export type UpdateTechnologicalMapMutationOptions = Apollo.BaseMutationOptions<UpdateTechnologicalMapMutation, UpdateTechnologicalMapMutationVariables>;
export const RestoreTechnologicalMapDocument = gql`
    mutation RestoreTechnologicalMap($technologicalMapId: Int!, $input: TechnologicalMapInput!, $branchId: Int!) {
  restoreTechnologicalMap(
    technologicalMapId: $technologicalMapId
    input: $input
    branchId: $branchId
  ) {
    id
    name
    description
  }
}
    `;
export type RestoreTechnologicalMapMutationFn = Apollo.MutationFunction<RestoreTechnologicalMapMutation, RestoreTechnologicalMapMutationVariables>;

/**
 * __useRestoreTechnologicalMapMutation__
 *
 * To run a mutation, you first call `useRestoreTechnologicalMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTechnologicalMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTechnologicalMapMutation, { data, loading, error }] = useRestoreTechnologicalMapMutation({
 *   variables: {
 *      technologicalMapId: // value for 'technologicalMapId'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useRestoreTechnologicalMapMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTechnologicalMapMutation, RestoreTechnologicalMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTechnologicalMapMutation, RestoreTechnologicalMapMutationVariables>(RestoreTechnologicalMapDocument, options);
      }
export type RestoreTechnologicalMapMutationHookResult = ReturnType<typeof useRestoreTechnologicalMapMutation>;
export type RestoreTechnologicalMapMutationResult = Apollo.MutationResult<RestoreTechnologicalMapMutation>;
export type RestoreTechnologicalMapMutationOptions = Apollo.BaseMutationOptions<RestoreTechnologicalMapMutation, RestoreTechnologicalMapMutationVariables>;
export const DeleteTechMapsDocument = gql`
    mutation deleteTechMaps($techMapIds: [Int!]!, $branchId: Int!) {
  deleteTechMaps(techMapIds: $techMapIds, branchId: $branchId) {
    deleted
    failed
  }
}
    `;
export type DeleteTechMapsMutationFn = Apollo.MutationFunction<DeleteTechMapsMutation, DeleteTechMapsMutationVariables>;

/**
 * __useDeleteTechMapsMutation__
 *
 * To run a mutation, you first call `useDeleteTechMapsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTechMapsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTechMapsMutation, { data, loading, error }] = useDeleteTechMapsMutation({
 *   variables: {
 *      techMapIds: // value for 'techMapIds'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useDeleteTechMapsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTechMapsMutation, DeleteTechMapsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTechMapsMutation, DeleteTechMapsMutationVariables>(DeleteTechMapsDocument, options);
      }
export type DeleteTechMapsMutationHookResult = ReturnType<typeof useDeleteTechMapsMutation>;
export type DeleteTechMapsMutationResult = Apollo.MutationResult<DeleteTechMapsMutation>;
export type DeleteTechMapsMutationOptions = Apollo.BaseMutationOptions<DeleteTechMapsMutation, DeleteTechMapsMutationVariables>;
export const UpdateTechMapServicesDocument = gql`
    mutation UpdateTechMapServices($serviceIds: [Int!]!, $connect: Boolean!, $techMapId: Int!, $branchId: Int!) {
  updateServiceConnection(
    serviceIds: $serviceIds
    connect: $connect
    techMapId: $techMapId
    branchId: $branchId
  )
}
    `;
export type UpdateTechMapServicesMutationFn = Apollo.MutationFunction<UpdateTechMapServicesMutation, UpdateTechMapServicesMutationVariables>;

/**
 * __useUpdateTechMapServicesMutation__
 *
 * To run a mutation, you first call `useUpdateTechMapServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechMapServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTechMapServicesMutation, { data, loading, error }] = useUpdateTechMapServicesMutation({
 *   variables: {
 *      serviceIds: // value for 'serviceIds'
 *      connect: // value for 'connect'
 *      techMapId: // value for 'techMapId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateTechMapServicesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTechMapServicesMutation, UpdateTechMapServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTechMapServicesMutation, UpdateTechMapServicesMutationVariables>(UpdateTechMapServicesDocument, options);
      }
export type UpdateTechMapServicesMutationHookResult = ReturnType<typeof useUpdateTechMapServicesMutation>;
export type UpdateTechMapServicesMutationResult = Apollo.MutationResult<UpdateTechMapServicesMutation>;
export type UpdateTechMapServicesMutationOptions = Apollo.BaseMutationOptions<UpdateTechMapServicesMutation, UpdateTechMapServicesMutationVariables>;
export const UpdateTechMapConnectionForServiceDocument = gql`
    mutation UpdateTechMapConnectionForService($techMapIds: [Int!]!, $connect: Boolean!, $serviceId: Int!, $branchId: Int!) {
  updateTechMapConnection(
    techMapIds: $techMapIds
    connect: $connect
    serviceId: $serviceId
    branchId: $branchId
  )
}
    `;
export type UpdateTechMapConnectionForServiceMutationFn = Apollo.MutationFunction<UpdateTechMapConnectionForServiceMutation, UpdateTechMapConnectionForServiceMutationVariables>;

/**
 * __useUpdateTechMapConnectionForServiceMutation__
 *
 * To run a mutation, you first call `useUpdateTechMapConnectionForServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTechMapConnectionForServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTechMapConnectionForServiceMutation, { data, loading, error }] = useUpdateTechMapConnectionForServiceMutation({
 *   variables: {
 *      techMapIds: // value for 'techMapIds'
 *      connect: // value for 'connect'
 *      serviceId: // value for 'serviceId'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateTechMapConnectionForServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTechMapConnectionForServiceMutation, UpdateTechMapConnectionForServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTechMapConnectionForServiceMutation, UpdateTechMapConnectionForServiceMutationVariables>(UpdateTechMapConnectionForServiceDocument, options);
      }
export type UpdateTechMapConnectionForServiceMutationHookResult = ReturnType<typeof useUpdateTechMapConnectionForServiceMutation>;
export type UpdateTechMapConnectionForServiceMutationResult = Apollo.MutationResult<UpdateTechMapConnectionForServiceMutation>;
export type UpdateTechMapConnectionForServiceMutationOptions = Apollo.BaseMutationOptions<UpdateTechMapConnectionForServiceMutation, UpdateTechMapConnectionForServiceMutationVariables>;
export type GetTechMapsCategoriesQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  delete?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  branchId: Types.Scalars['Int']['input'];
}>;


export type GetTechMapsCategoriesQuery = { __typename?: 'Query', TechMapCategories?: { __typename?: 'TechMapCategoryNewPaginated', items?: Array<{ __typename?: 'TechMapCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, parentCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, deleted: boolean, bookingQrLink: string, isPremiumOn: boolean, paidFeaturesPaginated: { __typename?: 'PaidFeaturePaginated', totalCount?: number | null } } | null, childCategories?: Array<{ __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null> | null }> | null } | null };

export type GetTechnologicalMapsQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  techMapId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  pageTechMapProducts?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPageTechMapProducts?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetTechnologicalMapsQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, technologicalMaps?: { __typename?: 'TechnologicalMapPaginated', currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, totalCount?: number | null, technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, description?: string | null, deleted: boolean, technologicalMapNewCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null, technologicalMapProductRelations?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, requiredQuantity?: number | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, product?: { __typename?: 'ProductProxy', id: number, name: string, deleted: boolean, cost?: string | null, price: string } | null }> | null, techMapProducts?: { __typename?: 'TechMapProductPaginated', totalCount?: number | null, techMapProducts?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, requiredQuantity?: number | null }> | null } | null, techMapServices?: { __typename?: 'TechMapServicePaginated', techMapServices?: Array<{ __typename?: 'TechnologicalMapServiceRelationProxy', id: number, connect: boolean }> | null } | null, technologicalMapServiceRelations?: Array<{ __typename?: 'TechnologicalMapServiceRelationProxy', id: number, connect: boolean, service?: { __typename?: 'ServiceProxy', id: number, name: string, description?: string | null, deleted: boolean, onlineRegistration: boolean } | null }> | null }> | null } | null } | null } | null };

export type GetTechMapServicesQueryVariables = Types.Exact<{
  techMapId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  connect?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetTechMapServicesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, servicesListForTechMap?: { __typename?: 'ServicePaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, services?: Array<{ __typename?: 'ServiceProxy', id: number, name: string, description?: string | null, onlineRegistration: boolean, deleted: boolean, serviceCategoryNew?: { __typename?: 'ServiceCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'ServiceCategoryNewProxy', id: number, name: string, deleted: boolean } | null, childCategories?: Array<{ __typename?: 'ServiceCategoryNewProxy', id: number, name: string, deleted: boolean } | null> | null } | null, technologicalMapServiceRelations?: Array<{ __typename?: 'TechnologicalMapServiceRelationProxy', id: number, connect: boolean, service?: { __typename?: 'ServiceProxy', id: number, name: string, deleted: boolean, onlineRegistration: boolean } | null }> | null }> | null } | null } | null } | null };

export type GetOneTechMapQueryVariables = Types.Exact<{
  techMapId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetOneTechMapQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, technologicalMaps?: { __typename?: 'TechnologicalMapPaginated', technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, description?: string | null, deleted: boolean, technologicalMapNewCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null } | null }> | null } | null } | null } | null };

export type GetConnectedServicesQueryVariables = Types.Exact<{
  techMapId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetConnectedServicesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, technologicalMaps?: { __typename?: 'TechnologicalMapPaginated', technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, deleted: boolean, technologicalMapServiceRelations?: Array<{ __typename?: 'TechnologicalMapServiceRelationProxy', id: number, connect: boolean, service?: { __typename?: 'ServiceProxy', id: number, name: string, onlineRegistration: boolean, deleted: boolean } | null }> | null }> | null } | null } | null } | null };

export type GetServiceQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetServiceQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, services?: { __typename?: 'ServicePaginated', services?: Array<{ __typename?: 'ServiceProxy', id: number, name: string }> | null } | null } | null } | null };

export type GetTechMapsForServiceQueryVariables = Types.Exact<{
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  companyId: Types.Scalars['Int']['input'];
  connect?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  serviceId: Types.Scalars['Int']['input'];
}>;


export type GetTechMapsForServiceQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, techMapListForServices?: { __typename?: 'TechnologicalMapPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, technologicalMaps?: Array<{ __typename?: 'TechnologicalMapProxy', id: number, name: string, description?: string | null, deleted: boolean, technologicalMapNewCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean, parentCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null, childCategories?: Array<{ __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null> | null } | null, technologicalMapServiceRelations?: Array<{ __typename?: 'TechnologicalMapServiceRelationProxy', id: number, connect: boolean, technologicalMap?: { __typename?: 'TechnologicalMapProxy', id: number, name: string, deleted: boolean } | null }> | null }> | null } | null } | null } | null };

export type CreateTechMapMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.TechnologicalMapInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type CreateTechMapMutation = { __typename?: 'Mutation', createTechnologicalMap: { __typename?: 'TechnologicalMapProxy', id: number, name: string, description?: string | null, technologicalMapProductRelations?: Array<{ __typename?: 'TechnologicalMapProductRelationProxy', id: number, requiredQuantity?: number | null, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null }> | null, technologicalMapServiceRelations?: Array<{ __typename?: 'TechnologicalMapServiceRelationProxy', id: number, connect: boolean, service?: { __typename?: 'ServiceProxy', id: number, deleted: boolean, name: string, onlineRegistration: boolean } | null }> | null } };

export type CreateTechMapsCategoryMutationVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  input: Types.TechMapCategoryNewInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type CreateTechMapsCategoryMutation = { __typename?: 'Mutation', createTechMapCategory: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, comment?: string | null, deleted: boolean, parentCategory?: { __typename?: 'TechMapCategoryNewProxy', id: number, name: string, deleted: boolean } | null } };

export type UpdateTechnologicalMapMutationVariables = Types.Exact<{
  technologicalMapId: Types.Scalars['Int']['input'];
  input: Types.TechnologicalMapInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateTechnologicalMapMutation = { __typename?: 'Mutation', updateTechnologicalMap: { __typename?: 'TechnologicalMapProxy', id: number, name: string, description?: string | null } };

export type RestoreTechnologicalMapMutationVariables = Types.Exact<{
  technologicalMapId: Types.Scalars['Int']['input'];
  input: Types.TechnologicalMapInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type RestoreTechnologicalMapMutation = { __typename?: 'Mutation', restoreTechnologicalMap: { __typename?: 'TechnologicalMapProxy', id: number, name: string, description?: string | null } };

export type DeleteTechMapsMutationVariables = Types.Exact<{
  techMapIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type DeleteTechMapsMutation = { __typename?: 'Mutation', deleteTechMaps: { __typename?: 'DeleteResponse', deleted: Array<number>, failed: Array<number> } };

export type UpdateTechMapServicesMutationVariables = Types.Exact<{
  serviceIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  connect: Types.Scalars['Boolean']['input'];
  techMapId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateTechMapServicesMutation = { __typename?: 'Mutation', updateServiceConnection: boolean };

export type UpdateTechMapConnectionForServiceMutationVariables = Types.Exact<{
  techMapIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
  connect: Types.Scalars['Boolean']['input'];
  serviceId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateTechMapConnectionForServiceMutation = { __typename?: 'Mutation', updateTechMapConnection: boolean };
